"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIXED_MODE_LABEL = exports.FIXED_MODE = exports.POSITION_LABEL = exports.POSITION = exports.TAB_TYPE_LABEL = exports.TAB_TYPE = exports.LIMIT = void 0;
exports.LIMIT = {
    MAX: 8
};
// 激活样式类型
exports.TAB_TYPE = {
    LINE: 0,
    CIRCLE: 1 // 圆形
};
exports.TAB_TYPE_LABEL = {
    [exports.TAB_TYPE.LINE]: '线段',
    [exports.TAB_TYPE.CIRCLE]: '圆形'
};
exports.POSITION = {
    TOP: 'top',
    MID: 'mid'
};
exports.POSITION_LABEL = {
    [exports.POSITION.TOP]: '屏幕顶部',
    [exports.POSITION.MID]: '屏幕中间'
};
exports.FIXED_MODE = {
    IS_NOT_IN_VIEWPORT: 0,
    IS_UPPER_VIEWPORT: 1 // 在视口上方
};
exports.FIXED_MODE_LABEL = {
    [exports.FIXED_MODE.IS_NOT_IN_VIEWPORT]: '锚点不在视口内时',
    [exports.FIXED_MODE.IS_UPPER_VIEWPORT]: '锚点在视口上方时'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLEtBQUssR0FBRztJQUNqQixHQUFHLEVBQUUsQ0FBQztDQUNULENBQUM7QUFFRixTQUFTO0FBQ0ksUUFBQSxRQUFRLEdBQUc7SUFDcEIsSUFBSSxFQUFFLENBQUM7SUFDUCxNQUFNLEVBQUUsQ0FBQyxDQUFDLEtBQUs7Q0FDbEIsQ0FBQztBQUNXLFFBQUEsY0FBYyxHQUFHO0lBQzFCLENBQUMsZ0JBQVEsQ0FBQyxJQUFJLENBQUMsRUFBRSxJQUFJO0lBQ3JCLENBQUMsZ0JBQVEsQ0FBQyxNQUFNLENBQUMsRUFBRSxJQUFJO0NBQzFCLENBQUM7QUFFVyxRQUFBLFFBQVEsR0FBRztJQUNwQixHQUFHLEVBQUUsS0FBSztJQUNWLEdBQUcsRUFBRSxLQUFLO0NBQ2IsQ0FBQztBQUNXLFFBQUEsY0FBYyxHQUFHO0lBQzFCLENBQUMsZ0JBQVEsQ0FBQyxHQUFHLENBQUMsRUFBRSxNQUFNO0lBQ3RCLENBQUMsZ0JBQVEsQ0FBQyxHQUFHLENBQUMsRUFBRSxNQUFNO0NBQ3pCLENBQUM7QUFFVyxRQUFBLFVBQVUsR0FBRztJQUN0QixrQkFBa0IsRUFBRSxDQUFDO0lBQ3JCLGlCQUFpQixFQUFFLENBQUMsQ0FBQyxRQUFRO0NBQ2hDLENBQUM7QUFFVyxRQUFBLGdCQUFnQixHQUFHO0lBQzVCLENBQUMsa0JBQVUsQ0FBQyxrQkFBa0IsQ0FBQyxFQUFFLFVBQVU7SUFDM0MsQ0FBQyxrQkFBVSxDQUFDLGlCQUFpQixDQUFDLEVBQUUsVUFBVTtDQUM3QyxDQUFDIn0=